import { Component, type ErrorInfo, type ReactNode } from 'react';
import { PremiumButton } from './ui/PremiumButton';
import { useI18n } from '../i18n';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

class ErrorBoundaryInner extends Component<Props & { title: string; description: string; reload: string }, State> {
  public state: State = { hasError: false, error: null };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  public render() {
    if (!this.state.hasError) return this.props.children;

    return <div className="min-h-dvh bg-sheriff-bg flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-sheriff-bg-elevated border border-sheriff-border rounded-2xl p-6 text-center">
        <div className="text-6xl mb-4" aria-hidden="true">⚠️</div>
        <h1 className="text-xl font-bold text-white mb-2">{this.props.title}</h1>
        <p className="text-sm text-sheriff-text-secondary mb-4">{this.props.description}</p>
        <PremiumButton onClick={() => window.location.reload()} variant="primary" fullWidth>{this.props.reload}</PremiumButton>
      </div>
    </div>;
  }
}

export function ErrorBoundary({ children }: Props) {
  const { t } = useI18n();
  return <ErrorBoundaryInner title={t('appErrorTitle')} description={t('appErrorDescription')} reload={t('reload')}>{children}</ErrorBoundaryInner>;
}
